import Link from 'next/link'
import Image from 'next/image'

import dayjs from '@/lib/dayjs/index'

import { EdsnDialogConfirm, EdsnText } from '@8percent/edsn-react'

import styles from './style.module.css'

import { useState } from 'react'

export type ImageObject = {
  url: string
  width: number
  height: number
}

type FeedProps = {
  id: string
  eventId: number
  title: string
  thumbnail: ImageObject
  startDate: string
  endDate: string
  state?: string
  isAlways: boolean
  redirectLink?: string
}

export default function Feed(props: FeedProps) {
  const [isCloseModal, setIsCloseModal] = useState(false)

  const detailPath = () => {
    return `/detail/${props.id}`
  }

  const feedClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    if (props.redirectLink) {
      if (props.state === 'finish') {
        setIsCloseModal(true)
        return
      }
      window.location.href = props.redirectLink
    } else {
      window.location.href = detailPath()
    }
  }

  return (
    <div className={styles.feed}>
      <EdsnDialogConfirm
        open={isCloseModal}
        onOpenChange={setIsCloseModal}
        title="종료된 이벤트"
        description="본 이벤트는 종료되어 참여가 불가능합니다."
        confirmLabel="확인"
        onConfirm={() => {
          setIsCloseModal(false)
        }}
      />
      <Link
        onClick={feedClick}
        href={{
          pathname: detailPath()
        }}
        prefetch={false}
      >
        <Image
          className={styles.feedImage}
          src={props.thumbnail.url}
          width={props.thumbnail.width}
          height={props.thumbnail.height}
          alt="이벤트 썸네일 이미지"
        />

        <EdsnText variant="body-m-regular" as="div">
          {props.title}
        </EdsnText>

        {props.isAlways ? (
          <EdsnText variant="caption-m-regular" color="neutral-quaternary" as="div">
            상시이벤트
          </EdsnText>
        ) : (
          <EdsnText variant="caption-m-regular" color="neutral-quaternary" as="div">
            {dayjs(props.startDate).format('YYYY-MM-DD')} ~{' '}
            {dayjs(props.endDate).format('YYYY-MM-DD')}
          </EdsnText>
        )}
      </Link>
    </div>
  )
}
